import { useEffect, useState } from 'react';
import { callApi } from '../utils/apiClient';
import { API_ENDPOINTS } from '../config/api/apiCall';


const useDesignationList = ({ editID, handleMessage }) => {
    const [isDesignationLoaded, setIsDesignationLoaded] = useState(false);
    const [designation, setDesignation] = useState([]);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [designationID, setDesignationID] = useState(0);

    // ✅ Async fetch function
    const fetchDesignationList = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {
            const data = await callApi(
                API_ENDPOINTS.DESIGNATION_GET,
                "POST",
                { "Content-Type": "application/json" },
                para
            );

            if (Array.isArray(data) && data.length > 0) {
                setDesignation(data);

                const initialDesignation = data.find((dept) => dept.id === selectedID);

                if (initialDesignation) {
                    setSelectedDesignation(initialDesignation);
                    setDesignationID(initialDesignation.id);
                }
            } else {
                setDesignation([]);
            }

            setIsDesignationLoaded(true);
        } catch (error) {
            handleMessage("error", error.message || "Something went wrong", "Error");
        }
    };

    // ✅ Proper useEffect
    useEffect(() => {
        if (!isDesignationLoaded && editID === 0) {
            fetchDesignationList();
        }
    }, [isDesignationLoaded, editID]);

    // ✅ Public loader
    const loadDesignationByID = async (selectedID) => {
        await fetchDesignationList(selectedID);
    };

    return {
        designation,
        selectedDesignation,
        designationID,
        setDesignation,
        setSelectedDesignation,
        setDesignationID,
        loadDesignationByID,
    };
};

export default useDesignationList;

